import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
  uniqBy,
} from "lodash-es";

// @vue/component
export default {
  name: "FaqAdminModalCreate",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    rubrik: {
      type: Array,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "fqe_frage",
            type: "text",
            label: "_LBL_FAQ_ADMIN_MODAL_CREATE_FRAGE_",
            required: true,
            maxlength: 200,
            view: "v",
            translate: true,
          },
          {
            id: "fqe_antwort",
            type: "richtext",
            label: "_LBL_FAQ_ADMIN_MODAL_CREATE_ANTWORT_",
            required: false,
            view: "v-alt",
            translate: true,
          },
          {
            id: "fqe_prio",
            type: "number",
            label: "_LBL_FAQ_ADMIN_MODAL_CREATE_PRIORITAET_",
            maxlength: 200,
            required: true,
            view: "v",
            translate: true,
          },
          {
            id: "rubrik",
            type: "select",
            label: "_LBL_FAQ_ADMIN_MODAL_CREATE_RUBRIK_",
            required: true,
            view: "v",
            keyId: "pk",
            keyLabel: "fqr_kbez",
            menuWidthAll: true,
            translate: true,
          },
          {
            id: "schlagworte",
            type: "multiselect",
            view: "v",
            label: "_LBL_FAQ_ADMIN_MODAL_CREATE_SCHLAGWORTE_",
            keyId: "pk",
            keyLabel: "sw_kbez",
            search: true,
            searchList: ["sw_kbez"],
            keyGroup: "gruppen_bez",
            menuWidthAll: true,
            closeClick: false,
          },
          {
            id: "medieneintraege",
            type: "selectordered",
            label: "_LBL_FAQ_ADMIN_DETAILS_MEDIENEINTRAEGE_",
            showLabel: true,
            view: "v",
            url: "medieneintrag/",
            keyId: "pk",
            keyLabel: "kme_kbez",
            search: true,
            translate: true,
          },
          {
            id: "fqe_oeffentlich",
            type: "boolean",
            label: "_LBL_FAQ_ADMIN_MODAL_CREATE_OEFFENTLICH_",
            translate: true,
            view: "v-alt",
          },
        ],
      },
      model: {
        schlagworte: [],
        medieneintraege: []
      },
      data: {
        schlagworte: [],
        rubrik: [],
        medieneintraege: []
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  created() {
    this.data.rubrik = this.rubrik;
    this.loadingRubriken();
    this.loadingSchlagwoerter();
  },
  methods: {
    loadingRubriken() {
      this.getListHttp({ url: "faqrubriken/" }).then(
        response => {
          this.data.rubrik = response;
        }
      );
    },

    loadingSchlagwoerter() {
      this.getListHttp({ url: "schlagworte/?for_model=faq.faqeintrag" }).then(
        response => {
          this.data.schlagworte = uniqBy(response, "sw_kbez");
        }
      );
    },

    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.postHttp({ url: "faqs/", data }).then(
        response => {
          this.addNotification({ text: "_MSG_FAQ_ADMIN_MODAL_CREATE_SUCCESS_" });
          this.close({ status: true });
          this.$goTo("root.adminfaqs.details", { id: response.pk });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
